<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text(v-if="product") {{ $t('edit') }} {{ $t('product') }}
              p.mb-0.h6.basic800--text(v-else) {{ $t('add') }} {{ $t('product') }}

        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4(style="overflow-x: hidden;")
              .product-image.d-flex
                p.h6.basic1000--text {{ $t('product_image') }}
                v-spacer
                v-btn.button-AA-tiny(v-if="resizeImageFileUrl" color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="handleAddMoreImagesDialog()")
                  v-icon.mr-1(small) mdi-plus
                  | {{ $t('add_photo') }}
              v-card.mb-3(v-if="resizeImageFileUrl" flat)
                div(align="center")
                  v-img(:src="resizeImageFileUrl" aspect-ratio="1" width="170")
                    template(v-slot:placeholder)
                      v-row(class="fill-height ma-0" align="center" justify="center")
                        v-progress-circular(indeterminate color="grey")
              v-card.mb-3(v-else outlined height="170" :style="`background-color: ${$vuetify.theme.themes[$theme].primaryT08}`")
                div.fill-height
                  div.d-flex.justify-center.align-end(style="height: 70%")
                    div
                      div.mb-2(align="center")
                        eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                      div.file-layout.mb-4
                        v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") upload
                        input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 60px !important")
                  div.d-flex.justify-center.align-end(style="height: 30%")
                    div.mb-4
                      div.c1.basic600--text.text-center {{ $t('max_image_filesize') }}
                      div.c1.basic600--text.text-center {{ $t('recommended_image_size') }}

              .guide.mb-2.d-flex
                eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15" style="margin-top: -1px")
                div.c1.basic600--text {{ $t('multiple_images_enabled_yezza_store') }}

              template(v-if="product && product.id")
                .product-image.d-flex.mt-5
                  p.h6.basic1000--text {{ $t('product_video') }}
                  v-spacer
                  div.file-layout(v-if="videoFile")
                    v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}")
                      v-icon.mr-1(small) mdi-plus
                      | {{ $t('change_video') }}
                    input.input-layout.change-video(type="file" @change="onFileChange2" accept="video/mp4" style="width: 114px !important" data-attr="edit-product-video")
                    v-btn.ml-2(icon small @click="openDeleteDialog = true")
                      eva-icon(name ="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="20" height="20")
                v-card.mb-3(v-if="videoFile" flat)
                  template(v-if="videoProgress")
                    div.d-flex.justify-center.align-center(style="height: 170px;")
                      v-progress-circular(v-if="videoProgress !== 100" :rotate="-90" :size="80" :width="8" :value="videoProgress" color="primary")
                      v-progress-circular(v-else :size="80" :width="5" indeterminate color="primary")
                  div(v-else align="center")
                    video(width="170" height="170" controls)
                      source(:src="videoFile" type="video/mp4")
                v-card.mb-3(v-else outlined height="170" :style="`background-color: ${$vuetify.theme.themes[$theme].primaryT08}`")
                  div.fill-height
                    div.d-flex.justify-center.align-end(style="height: 70%")
                      div
                        div.mb-2(align="center")
                          eva-icon(name="film-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                        div.file-layout.mb-4(v-if="!videoProgress")
                          v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") upload
                          input.input-layout.add-video(type="file" @change="onFileChange2" accept="video/mp4" style="width: 60px !important" data-attr="add-product-video")
                    div.d-flex.justify-center(:class="videoProgress ? 'align-center' : 'align-end'" style="height: 30%")
                        template(v-if="videoProgress")
                          v-progress-linear.mx-4(v-if="videoProgress !== 100" :height="5" :value="videoProgress" color="primary")
                          v-progress-linear.mx-4(v-else :height="5" indeterminate color="primary")
                        div.mb-4(v-else)
                          div.c1.basic600--text.text-center {{ $t('max_video_filesize') }}
                          div.c1.basic600--text.text-center {{ $t('recommended_video_size') }}

              .guide.mb-2.d-flex
                eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15" style="margin-top: -1px")
                div.c1.basic600--text {{ $t('video_enabled_yezza_store') }}

              p.h6.basic1000--text.mt-5 {{ $t('details') }}

              .product-name
                p.mb-1.label.basic600--text.text-uppercase {{ $t('product_name.label') }}*
                v-text-field.mt-2(v-model='name' :placeholder="$t('product_name.placeholder')" background-color="basic200" outlined dense height="40" persistent-hint :rules="rules.not_empty" counter :maxlength="145")

              .product-price
                p.mb-1.label.basic600--text.text-uppercase {{ $t('price.label') }}*
                v-text-field.mt-2(v-model='price' :placeholder="$t('price.placeholder')" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" :readonly="checkVariants")

              .weight(v-if="setweight")
                p.mb-1.label.basic600--text.text-uppercase(:style="!checkVariants || `color: ${$vuetify.theme.themes[$theme].basic600T48} !important`") {{ $t('weight.label') }}*
                v-text-field.mt-2(v-model='weight' :placeholder="$t('weight.placeholder')" background-color="basic200" height="40" outlined dense type="number" :rules="setweight && !checkVariants ? rules.weight : []" suffix="kg" :disabled="checkVariants")

              .dimension(v-if="setdimension")
                p.mb-1.label.basic600--text.text-uppercase(:style="!checkVariants || `color: ${$vuetify.theme.themes[$theme].basic600T48} !important`") {{ $t('dimension.label') }}*
                div.d-flex
                  v-text-field.mt-2(v-model='length' :placeholder="$t('dimension.placeholder_1')" background-color="basic200" height="40" outlined dense type="number" :rules="setdimension && !checkVariants ? rules.dimension : []" suffix="cm" :disabled="checkVariants")
                  div.basic600--text.mt-4.mx-1 X
                  v-text-field.mt-2(v-model='width' :placeholder="$t('dimension.placeholder_2')" background-color="basic200" height="40" outlined dense type="number" :rules="setdimension && !checkVariants ? rules.dimension : []" suffix="cm" :disabled="checkVariants")
                  div.basic600--text.mt-4.mx-1 X
                  v-text-field.mt-2(v-model='height' :placeholder="$t('dimension.placeholder_3')" background-color="basic200" height="40" outlined dense type="number" :rules="setdimension && !checkVariants ? rules.dimension : []" suffix="cm" :disabled="checkVariants")
              
              .description
                p.mb-1.label.basic600--text.text-uppercase {{ $t('description.label') }}
                v-textarea.mt-2(v-model='description' :placeholder="$t('description.placeholder')" outlined dense persistent-hint counter background-color="basic200")
                .guide.mb-2.d-flex
                  eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
                  div.c1.basic600--text {{ $t('description.info') }}

              v-row
                v-divider.basic300.mt-3

              p.h6.basic1000--text.mt-5(:style="!useVariantInventory || `color: ${$vuetify.theme.themes[$theme].basic600T48} !important`") {{ $t('inventory') }}

              div.inventory.d-flex
                y-checkbox.my-auto.mx-0.pa-0(v-model="inventory" hide-details :disabled="useVariantInventory")
                  template(v-slot:label)
                    div.p1.my-auto(:style="!useVariantInventory || `color: ${$vuetify.theme.themes[$theme].basic600T48}`") {{ $t('product_limited_stock') }}

              .quantity.mt-6(v-if="inventory && !useVariantInventory")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('quantity.label') }}*
                v-text-field.mt-2(ref='quantity' v-model='quantity' :placeholder="$t('quantity.placeholder')" background-color="basic200" height="40" hide-details outlined dense type="number")

              .max-order(v-if="Auth('component', '/admin/products#max_order_quantity')")
                p.h6.mt-5.basic1000--text(:style="!useVariantOrderLimit || `color: ${$vuetify.theme.themes[$theme].basic600T48} !important`") {{ $t('order_limit') }}
                div.d-flex
                  y-checkbox.my-auto.mx-0.pa-0(v-model="hasOrderLimit" hide-details :disabled="useVariantOrderLimit")
                    template(v-slot:label)
                      div.p1.my-auto(:style="!useVariantOrderLimit || `color: ${$vuetify.theme.themes[$theme].basic600T48}`") {{ $t('maximum_quantity_per_order') }}
                
                .limit.mt-6(v-if="hasOrderLimit && !useVariantOrderLimit")
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('limit.label') }}*
                  v-text-field.mt-2(ref='limit' v-model='orderLimit' :placeholder="$t('limit.placeholder')" background-color="basic200" height="40" hide-details outlined dense type="number")
                  
              .variants
                p.h6.mt-5.basic1000--text(:style="!checkAddons || `color: ${$vuetify.theme.themes[$theme].basic600T48} !important`") {{ $t('variants') }}

                div.variant.d-flex
                  y-checkbox.my-auto.mx-0.pa-0(v-model="checkVariants" hide-details :disabled="checkAddons" :readonly="hasOptions")
                    template(v-slot:label)
                      div.p1.my-auto(:style="!checkAddons || `color: ${$vuetify.theme.themes[$theme].basic600T48}`") {{ $t('product_comes_multiple_option') }}

              .variant-button.pt-5(align="center" v-if="checkVariants")
                v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="openEditVariantDialog = true")
                  template(v-if="hasOptions")
                    v-icon.mr-1(small) mdi-pencil
                    | {{ $t('edit_variant') }}
                  template(v-else)
                    v-icon.mr-1(small) mdi-plus
                    | {{ $t('add_variant') }}

              .addon
                p.h6.mt-5.basic1000--text(:style="!checkVariants || `color: ${$vuetify.theme.themes[$theme].basic600T48} !important`") {{ $t('addons') }}

                div.addon.d-flex
                  y-checkbox.my-auto.mx-0.pa-0(v-model="checkAddons" hide-details :disabled="checkVariants" :readonly="hasAddons")
                    template(v-slot:label)
                      div.p1.my-auto(:style="!checkVariants || `color: ${$vuetify.theme.themes[$theme].basic600T48}`") {{ $t('product_has_addon') }}
              .addon-button.pt-5(align="center" v-if="checkAddons")
                v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="handleOpenManageAddOnsDialog")
                  v-icon.mr-1(small) mdi-square-edit-outline
                  | {{ $t('manage_addons') }}

              .notes
                p.h6.mt-5.basic1000--text(:style="!checkAddons || `color: ${$vuetify.theme.themes[$theme].basic600T48} !important`") {{ $t('product_notes') }}

                div.variant.d-flex
                  y-checkbox.my-auto.mx-0.pa-0(v-model="checkNotes" hide-details :readonly="hasNotes")
                    template(v-slot:label)
                      div.p1.my-auto {{ $t('product_has_custom_notes') }}
              
              .notes-button.pt-4(align="center" v-if="checkNotes")
                v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="openEditNotesDialog = true")
                  template
                    v-icon.mr-1(small) mdi-plus
                    | {{ hasNotes ? $t('edit') : $t('assign') }} {{ $t('product_notes') }}
              
                .guide.d-flex.mt-4
                  eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
                  div.c1.basic600--text {{ $t('only_available_yezza_store') }}
                
              v-row
                v-divider.basic300.mt-5
              .yezza-store(v-if="Auth('root', 'store_features')")
                p.h6.basic1000--text.mt-5.mb-3 {{ $t('yezza_store_features') }}
                  //- span.basic500--text (optional)

                .product-category(v-if="categoryList.length > 0")
                  div.d-flex.align-end
                    p.mb-1.label.basic600--text.text-uppercase {{ $t('product_categories') }}
                    v-spacer
                    v-btn(icon small @click="category_keyboard = !category_keyboard")
                      v-icon(color="primary") {{ category_keyboard ? 'mdi-keyboard-outline' : 'mdi-keyboard-off-outline' }}
                  v-combobox.mt-2(v-model="categories" background-color="basic200" outlined dense :loading="memberSearchLoading" item-text="name" :search-input.sync="categorySearch" :items="categoryList" hide-selected hide-no-data chips placeholder="Select product category" multiple :menu-props="({ 'closeOnContentClick': false, 'maxHeight': category_keyboard ? '35%' : '45%' })" :type="category_keyboard ? 'text' : 'button'")
                    template(v-slot:selection="{ attrs, item, select, selected }")
                      v-chip.mb-1.s2(color="basic600" v-bind="attrs" outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" :input-value="selected" small close-icon="mdi-close" close @click.stop @click:close="removeSales(item)") {{ item.name }}
                    template(v-slot:item="{ index, item }")
                      v-layout
                        v-list-item-content
                          v-list-item-title(v-text="item.name")
                  
                .slash-price
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('slash_price.label') }}
                  v-text-field.mt-2(v-model='slashPrice' :placeholder="$t('slash_price.placeholder')" background-color="basic200" height="40" outlined dense type="number" hide-details :rules="slashPrice? rules.has_quantity : []" :prefix="$currency.symbol")
                  .guide.d-flex.mt-3
                    eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
                    div.c1.basic600--text {{ $t('appear_as_slashed_price') }}
                      span.c1.danger--text.text-decoration-line-through {{ $currency.symbol }}50
                
                .meta-title.mt-5
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('meta_description') }}
                  v-text-field.mt-2(v-model='metaTitle' placeholder="Enter meta title" background-color="basic200" height="40" outlined dense :maxlength="100")

                .meta-description.mb-5
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('meta_description') }}
                  v-textarea.mt-2(v-model='metaDescription' placeholder="Enter meta description" background-color="basic200" hide-details outlined dense :maxlength="200")
                  .guide.mt-3.d-flex
                    eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
                    div.c1.basic600--text {{ $t('meta_keywords_note') }} 
                      a.text-decoration-none.textColorAccent--text(href="https://webmasters.googleblog.com/2009/09/google-does-not-use-keywords-meta-tag.html" target="_blank") {{ $t('meta_keywords_ref') }}

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading" dark)
            .button-AA-medium.basic100--text(v-if="product") {{ $t('save') }}
            .button-AA-medium.basic100--text(v-else) {{ $t('add') }}

    .modals
      add-product-variant(v-if="openEditVariantDialog" :open.sync="openEditVariantDialog" :parentProduct="parentProduct" :setweight="setweight" :setdimension="setdimension" :parentProductOptions="options ? options : parentOptions" :parentProductVariants="variants ? variants : parentVariants" :tempRemoveVariants.sync="tempRemoveVariants" :tempOptionImages.sync="tempOptionImages" @updateVariantData="updateVariantData" @refetch="fetchProductDetails" @removeAllVariants="removeAllVariants" :removeAllVariantImages.sync="removeAllVariantImages")
      manage-product-add-ons(v-if="openManageAddOnsDialog" :open.sync="openManageAddOnsDialog" :productId="product.id" :setweight="setweight" :setdimension="setdimension" @activated="handleActivateAddOn")
      manage-product-Images(v-if="openAddMoreImagesDialog" :open.sync="openAddMoreImagesDialog" :productId="product.id" :mainImage="resizeImageFileUrl" @updateImage="handleUpdateImage($event)")
      assign-product-note(v-if="openEditNotesDialog" :open.sync="openEditNotesDialog" :company="company" :product="product")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('remove_video') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('remove_video_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isDeleting" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddProductVariant from '@/components/dialogs/AddProductVariant.vue'
import ManageProductAddOns from '@/components/dialogs/ManageProductAddOns.vue'
import ManageProductImages from '@/components/dialogs/ManageProductImages.vue'
import AssignProductNote from '@/components/productnotes/dialogs/AssignProductNote.vue'
import { resizeImage } from '@/utils'

let asyncForEach = async function(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}
export default {
  name: 'AddProductDialog',
  props: ['open', 'parentProduct', 'setweight', 'setdimension'],
  components: { AddProductVariant, ManageProductAddOns, ManageProductImages, AssignProductNote },
  data: () => ({
    name: null,
    price: null,
    slashPrice: null,
    weight: null,
    length: null,
    width: null,
    height: null,
    description: null,
    inventory: false,
    quantity: null,
    hasOrderLimit: false,
    orderLimit: null,
    checkVariants: false,
    checkNotes: false,
    checkAddons: false,
    members: '',
    categories: [],
    categorySearch: null,
    categoryList: [],
    metaTitle: null,
    metaDescription: null,
    memberSearchLoading: false,
    openEditVariantDialog: false,
    openManageAddOnsDialog: false,
    openAddMoreImagesDialog: false,
    openEditNotesDialog: false,
    loadSaveProduct: false,
    loadSaveOption: false,
    loadSaveVariants: false,
    startLoad: false,
    successMessage: '',
    option: null,
    parentOptions: null,
    parentVariants: null,
    options: null,
    variants: null,
    tempRemoveVariants: {
      options: [],
      specs: []
    },
    tempOptionImages: {
      deleting: [],
      uploading: []
    },
    removeAllVariantImages: false,
    category_keyboard: false,
    openDeleteDialog: false,
    isDeleting: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      number_not_empty: [v => v !== null || 'This field is required'],
      is_selected: [v => v !== null || 'This field is required'],
      has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
      has_items: [v => !!v || 'This field is required'],
      weight: [v => !!v || 'This field is required', v => v >= 0.1 || 'Weight should not be below 0.1 KG', v => v <= 60 || 'Weight should not be above 60 KG'],
      dimension: [v => !!v || 'This field is required', v => v > 0 || 'measure should not be below 1 cm'],
    },
    resizeImageFileUrl: '',
    resizeImageFile: null,
    videoFile: null,
    videoProgress: null,
    notes: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    product: {
      get() {
        return this.parentProduct
      },
      set(newValue) {
        this.$emit('update:parentProduct', newValue)
      }
    },
    authMember() {
      return this.$store.state.user.member
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    useVariantInventory() {
      if (this.parentVariants || this.variants) {
        let hasInventory = false
        if (this.variants) {
          this.variants.forEach(variant => {
            if (variant.product.inventory_enabled) {
              hasInventory = true
            }
          })
        } else {
          this.parentVariants.forEach(variant => {
            if (variant.product.inventory_enabled) {
              hasInventory = true
            }
          })
        }
        return hasInventory
      }
      return false
    },
    useVariantOrderLimit() {
      if (this.parentVariants || this.variants) {
        let hasOrderLimit = false
        if (this.variants) {
          this.variants.forEach(variant => {
            if (variant.product.order_limit && (parseInt(variant.product.order_limit) || parseInt(variant.product.order_limit) == 0)) {
              hasOrderLimit = true
            }
          })
        } else {
          this.parentVariants.forEach(variant => {
            if (variant.product.order_limit && (parseInt(variant.product.order_limit) || parseInt(variant.product.order_limit) == 0)) {
              hasOrderLimit = true
            }
          })
        }
        return hasOrderLimit
      }
      return false
    },
    hasOptions() {
      if (this.parentOptions && this.parentOptions.length > 0) {
        return true
      }
      return false
    },
    hasAddons() {
      if (this.product && this.product.has_addons) {
        return true
      }
      return false
    },
    hasNotes() {
      if (this.notes.length > 0) {
        return true
      }
      return false
    },
    isLoading() {
      if (this.loadSaveProduct || this.loadSaveOption || this.loadSaveVariants) {
        return true
      }
      return false
    },
    hasToDeleteVariants() {
      let result = false
      for (const key in this.deleteVariants) {
        if (this.deleteVariants[key].length > 0) result = true
      }
      return result
    }
  },
  watch: {
    categorySearch() {
      if (this.memberList.length != 0) {
        return
      }
      this.startSearchMembers()
    },
    hasOptions: {
      immediate: true,
      handler(val) {
        this.checkVariants = val
      }
    },
    hasAddons: {
      immediate: true,
      handler(val) {
        this.checkAddons = val
      }
    },
    hasNotes: {
      immediate: true,
      handler(val) {
        this.checkNotes = val
      }
    },
    useVariantInventory(val) {
      this.inventory = !val
    },
    useVariantOrderLimit(val) {
      this.hasOrderLimit = !val
    },
    isLoading(val) {
      if (this.startLoad) {
        if (!val) {
          if (this.successMessage) {
            this.showMessage(['success', this.successMessage])
          }
          this.startLoad = false
          this.showModal = false
          this.successMessage = ''
        }
      }
    },
    // Update parent price if variants changes
    variants(val) {
      this.updateParentPrice(val)
    }
  },
  mounted() {
    this.startSearchMembers()
    if (this.product) {
      if (this.product.image) {
        this.resizeImageFileUrl = this.product.image.file
      }
      if (this.product.video) {
        this.videoFile = this.product.video.file
      }
      this.name = this.product.name
      this.price = this.product.price / this.$currency.multiplier
      if (this.product.compare_at_price) {
        this.slashPrice = this.product.compare_at_price / this.$currency.multiplier
      }
      this.weight = this.product.weight
      this.length = this.product.length
      this.width = this.product.width
      this.height = this.product.height
      this.description = this.product.description
      this.quantity = this.product.inventory_qty || 0
      if (this.product.inventory_enabled) {
        this.inventory = true
      }
      this.orderLimit = this.product.order_limit || 0
      if (this.product.order_limit_enabled) {
        this.hasOrderLimit = true
      }
      if (this.product.meta_title) {
        this.metaTitle = this.product.meta_title
      }
      if (this.product.meta_description) {
        this.metaDescription = this.product.meta_description
      }
      if (this.product.members) {
        this.members = this.product.members
      }
      this.categories = this.product.categories
      this.fetchProductDetails()
      this.fetchProductNotes()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    getSearchText(item) {
      return item.user.first_name + ' ' + item.user.last_name + ' ' + item.user.email
    },
    updateVariantData({ options, variants }) {
      // Deep clone all data
      this.options = JSON.parse(JSON.stringify(options))
      this.variants = JSON.parse(JSON.stringify(variants))
    },
    fetchProductDetails() {
      this.axios.get(`/products/${this.product.id}?expand=options,variants`).then(resp => {
        this.product = resp.data
        this.parentOptions = resp.data.options.length > 0 ? resp.data.options : null
        this.parentVariants = resp.data.variants.length > 0 ? resp.data.variants : null
        if (this.parentVariants) {
          this.updateParentPrice(this.parentVariants)
        }
      })
    },
    fetchProductNotes() {
      this.axios.get(`/products/${this.product.id}/notes/`).then(resp => {
        this.notes = resp.data.results.map(p => (p.id))
      })
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      // Check options and variants
      if (this.checkVariants) {
        // For first time user setup
        if (!this.product) {
          if (!this.options || !this.variants) {
            this.showMessage(['error', this.$t('error_message.please_setup_your_variant')])
            return
          }
        } else {
          // For existing product but no variants set
          if ((!this.parentVariants || !this.parentVariants) && (!this.options || !this.variants)) {
            this.showMessage(['error', this.$t('error_message.please_setup_your_variant')])
            return
          }
        }
      }
      this.startLoad = true
      var memberIds = [this.authMember.id]
      this.loadSaveProduct = true
      var params = new FormData()
      params.set('company', this.company.id)
      params.set('name', this.name)
      params.set(
        'price',
        parseFloat(this.price)
          .toFixed(this.$currency.exponent)
          .replace('.', '')
      )
      if (this.slashPrice) {
        params.set(
          'compare_at_price',
          parseFloat(this.slashPrice)
            .toFixed(this.$currency.exponent)
            .replace('.', '')
        )
      } else {
        params.set('compare_at_price', 0)
      }
      if (this.weight && !this.checkVariants) {
        params.set('weight', this.weight)
      }
      if (this.length && !this.checkVariants) {
        params.set('length', this.length)
      }
      if (this.width && !this.checkVariants) {
        params.set('width', this.width)
      }
      if (this.height && !this.checkVariants) {
        params.set('height', this.height)
      }
      params.set('description', this.description || '')
      if (this.inventory) {
        params.set('inventory_qty', this.quantity)
        params.set('inventory_enabled', true)
      } else {
        params.set('inventory_enabled', false)
      }
      if (this.hasOrderLimit) {
        params.set('order_limit', this.orderLimit)
        params.set('order_limit_enabled', true)
      } else {
        params.set('order_limit_enabled', false)
      }
      if (this.resizeImageFile) {
        params.append('image', this.resizeImageFile)
      }
      if (this.metaTitle) {
        params.set('meta_title', this.metaTitle)
      } else {
        params.set('meta_title', '')
      }
      if (this.metaDescription) {
        params.set('meta_description', this.metaDescription)
      } else {
        params.set('meta_description', '')
      }
      memberIds.forEach(mid => {
        params.set('members', mid)
      })
      this.categories.forEach(category => {
        params.append('categories', category.id)
      })
      if (this.product) {
        this.axios
          .put(`/products/${this.product.id}/`, params)
          .then(resp => {
            // this.saveOption(resp.data)
            if (this.options) {
              this.saveOption(resp.data)
            }
            this.successMessage = 'Product edited'
            this.product = resp.data
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loadSaveProduct = false
          })
        return
      }
      this.axios
        .post(`/products/`, params)
        .then(resp => {
          // this.saveOption(resp.data)
          if (this.options) {
            this.saveOption(resp.data)
          }
          this.successMessage = 'Product added'
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.loadSaveProduct = false
        })
    },
    async saveOption(product) {
      this.loadSaveOption = true
      // Map back options to find tmp id (set to null)
      this.options.forEach(option => {
        option.specs.forEach(spec => {
          // save tempId to use later for new spec
          spec.tempId = typeof spec.id === 'string' ? spec.id : null
          spec.id = typeof spec.id === 'string' ? null : spec.id
          // Remove images if any
          if (spec.images) {
            delete spec.images
          }
        })
      })
      // Remove option first before create any new options/variants
      if (this.tempRemoveVariants.options.length > 0) {
        await asyncForEach(this.tempRemoveVariants.options, async option => {
          try {
            await this.axios.delete(`/products/${product.id}/options/${option.id}`)
          } catch (error) {
            console.log(error)
            // this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            // this.loadSaveOption = true
          }
        })
      }
      // Remove specs first before create any new options/variants
      if (this.tempRemoveVariants.specs.length > 0) {
        await asyncForEach(this.tempRemoveVariants.specs, async ({ parentOptionId, spec }) => {
          try {
            await this.axios.delete(`/products/${product.id}/options/${parentOptionId}/mappers/${spec.id}`)
          } catch (error) {
            console.log(error)
            // this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            // this.loadSaveOption = true
          }
        })
      }
      // Create options
      this.axios
        .post(`/products/${product.id}/options`, { options: this.options })
        .then(async resp => {
          // Map back new id to tmp id if any
          this.options.forEach((option, optionIndex) => {
            option.specs.forEach((spec, specIndex) => {
              if (spec.tempId) {
                spec.id = resp.data[optionIndex].specs[specIndex].id
              }
            })
          })
          // Handling images
          if (this.removeAllVariantImages) {
            // Delete all variant images from first option
            // Need to call api to get all spec images, crazy init?
            let pkList = []
            await asyncForEach(this.options, async (option, optionIndex) => {
              if (optionIndex === 0) {
                await asyncForEach(option.specs, async spec => {
                  const resp = await this.axios.get(`/products/${product.id}/mapper_images/${spec.id}`)
                  pkList.push(resp.data)
                })
              }
            })
            pkList = pkList
              .flat()
              .map(list => list.id)
              .join(',')
            try {
              await this.axios.post(`/products/${product.id}/mapper_images?delete=${pkList}`)
            } catch (error) {
              console.log(error)
            }
          } else {
            // Delete images if any
            if (this.tempOptionImages.deleting.length > 0) {
              const pkList = this.tempOptionImages.deleting
                .map(deleting => deleting.images)
                .flat()
                .join(',')
              try {
                await this.axios.post(`/products/${product.id}/mapper_images?delete=${pkList}`)
              } catch (error) {
                console.log(error)
              }
            }
            // Upload images if any
            if (this.tempOptionImages.uploading.length > 0) {
              await asyncForEach(this.tempOptionImages.uploading, async imageGroup => {
                let specId = imageGroup.specId
                if (typeof specId === 'string') {
                  this.options.forEach(option => {
                    option.specs.forEach(spec => {
                      if (spec.tempId === imageGroup.specId) {
                        specId = spec.id
                      }
                    })
                  })
                }
                // Create formdata for images
                let params = new FormData()
                imageGroup.images.forEach(image => {
                  params.append('images', image.file)
                })
                try {
                  await this.axios.post(`/products/${product.id}/mapper_images/${specId}`, params)
                } catch (error) {
                  console.log(error)
                  // this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                  // this.loadSaveOption = true
                }
              })
            }
          }
          // // Save variants
          this.saveVariants(product)
        })
        .finally(() => {
          this.loadSaveOption = false
        })
    },
    saveVariants(product) {
      this.loadSaveVariants = true
      // Map id of each variant if spec id null
      const variants = this.variants.map(variant => {
        if (variant.specs.some(spec => typeof spec === 'string')) {
          variant.specs = variant.specs.map(spec => {
            let id = null
            this.options.forEach(option => {
              const found = option.specs.filter(updatedSpec => updatedSpec.tempId === spec || updatedSpec.id === spec)
              if (found.length > 0) {
                id = found[0].id
              }
            })
            return id
          })
        }
        return variant
      })

      this.axios
        .post(`/products/${product.id}/variants`, { variants })
        .then(() => {})
        .finally(() => {
          this.loadSaveVariants = false
        })
    },
    removeAllVariants() {
      // remove all options (no need to await)
      if (this.parentOptions) {
        this.parentOptions.forEach(option => {
          this.axios.delete(`/products/${this.parentProduct.id}/options/${option.id}`)
        })
      }
      this.parentVariants = null
      this.parentOptions = null
      this.variants = null
      this.options = null
      this.checkVariants = false
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    onFileChange2(e) {
      let files = e.target.files
      if (!files.length) {
        return
      }
      var formData = new FormData()
      formData.append('video', files[0])
      this.$axios
        .patch(`/products/${this.product.id}/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent => (this.videoProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total))
        })
        .then(resp => {
          if (this.videoProgress === 100) {
            this.videoProgress = null
          }
          this.product.video = resp.data.video
          this.videoFile = resp.data.video.file
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    onFilterChanged() {
      setTimeout(() => {
        this.$refs.selectMembers.isMenuActive = false
      }, 50)
    },
    handleActivateAddOn() {
      this.product.has_addons = true
    },
    handleOpenManageAddOnsDialog() {
      if (!this.product) {
        this.showMessage(['error', this.$t('error_message.add_product_before_addons')])
        return
      }
      this.openManageAddOnsDialog = true
    },
    handleAddMoreImagesDialog() {
      if (!this.product) {
        this.showMessage(['error', this.$t('error_message.add_product_before_image')])
        return
      }
      this.openAddMoreImagesDialog = true
    },
    handleUpdateImage(val) {
      this.resizeImageFileUrl = val[0]
      this.resizeImageFile = val[1]
    },
    startSearchMembers() {
      this.memberSearchLoading = true
      this.$axios
        .get(`/product_categories/?page_size=-1&company=${this.company.id}&ordering=-id`)
        .then(resp => {
          if (resp.data.results) {
            this.categoryList = resp.data.results
          }
        })
        .catch(() => {})
        .finally(() => (this.memberSearchLoading = false))
    },
    removeSales(item) {
      let index = this.categories
        .map(m => {
          return m.id
        })
        .indexOf(item.id)
      if (index >= 0) this.categories.splice(index, 1)
    },
    startDelete() {
      this.isDeleting = true
      this.axios
        .get(`/products/${this.product.id}/remove_video`)
        .then(() => {
          this.product.video = null
          this.videoFile = null
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isDeleting = false
        })
    },
    // Update parent price to lowest variant price, if variant price changes
    updateParentPrice(variants) {
      const getLowestPrice = Math.min(...variants.map(variant => Number(variant.product.price)))
      this.price = getLowestPrice / this.$currency.multiplier
    }
  }
}
</script>

<style scoped>
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "product_name": {
      "label": "Name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "slash_price": {
      "label": "Price before Discount",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Max weight = 60 kg"
    },
    "dimension": {
      "label": "Dimension",
      "placeholder_1": "Length",
      "placeholder_2": "Width",
      "placeholder_3": "Height"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write product description here",
      "info": "For optimized design, keep your description within 160 characters"
    },
    "quantity": {
      "label": "In Stock",
      "placeholder": "How many stock left"
    },
    "limit": {
      "label": "Maximum quantity",
      "placeholder": "Maximum quantity per order"
    },
    "meta_keywords_note": "Note: Meta keywords is not supported.",
    "meta_keywords_ref": "More info here.",
    "multiple_images_enabled_yezza_store": "Multiple images are enabled only for Yezza Store",
    "video_enabled_yezza_store": "Product video are enabled only for Yezza Store",
    "maximum_quantity_per_order": "This product has maximum quantity per order",
    "product_comes_multiple_option": "This product comes in multiple options",
    "product_has_addon": "This product has add-on items",
    "product_has_custom_notes": "This product has custom notes",
    "only_available_yezza_store": "This is only available in Yezza Store for now.",
    "appear_as_slashed_price": "Will appear as slashed price next to selling price e.g. ",
    "remove_video_confirmation": "Are you sure you want to remove this video?"
  },
  "id": {
    "product_name": {
      "label": "Nama",
      "placeholder": "Tulis nama produk di sini"
    },
    "price": {
      "label": "Harga",
      "placeholder": "0"
    },
    "slash_price": {
      "label": "Harga sebelum diskon",
      "placeholder": "0"
    },
    "weight": {
      "label": "Berat",
      "placeholder": "Berat Maksimal = 60 kg"
    },
    "dimension": {
      "label": "Ukuran",
      "placeholder_1": "Panjang",
      "placeholder_2": "Lebar",
      "placeholder_3": "Tinggi"
    },
    "description": {
      "label": "Deskripsi",
      "placeholder": "Tulis Deskripsi produk di sini",
      "info": "Untuk desain yang dioptimalkan, simpan deskripsi kamu dalam 160 karakter"
    },
    "quantity": {
      "label": "Jumlah Stok",
      "placeholder": "Jumlah Sisa Stok"
    },
    "limit": {
      "label": "Jumlah Maksimal",
      "placeholder": "Jumlah maksimum per pesanan"
    },
    "meta_keywords_note": "Catatan: Sub Kata kunci tidak tersedia",
    "meta_keywords_ref": "Info lebih lanjut disini",
    "multiple_images_enabled_yezza_store": "Beberapa gambar diizinkan hanya untuk Yezza Store",
    "video_enabled_yezza_store": "Video produk hanya diizinkan untuk Yezza Store",
    "maximum_quantity_per_order": "Produk ini memiliki jumlah maksimum per pesanan",
    "product_comes_multiple_option": "Produk ini hadir dalam beberapa pilihan",
    "product_has_addon": "Produk ini mempunyai item add-on",
    "product_has_custom_notes": "Produk ini memiliki catatan khusus",
    "only_available_yezza_store": "Diizinkan hanya untuk Yezza Store.",
    "appear_as_slashed_price": "akan muncul potongan harga di sebelah harga jual mis. RP {50/number} ",
    "remove_video_confirmation": "Apakah kamu yakin ingin menghapus video ini?"
  }
}
</i18n>
